<div class="container">

    <div class="text-head">
        <h1>404 - Página NO encontrada.</h1>
    </div>

</div>